module.exports = __webpack_public_path__ + "img/extended.2aa5d277.png";